(function () {  
  async function insertSectionCartDrawer() {
    if (document.querySelector('#CartDrawer .cart-drawer-items-wrapper')) return;

    var cartDrawerItems = document.querySelector('#CartDrawer cart-drawer-items');
    if (!cartDrawerItems) return;

    if (cartDrawerItems.classList.contains('is-empty')) return;

    var wrapper = document.createElement('div');
    wrapper.classList.add('cart-drawer-items-wrapper');
    cartDrawerItems.parentNode.insertBefore(wrapper, cartDrawerItems);
    wrapper.appendChild(cartDrawerItems);

    const upsells = document.querySelector('#cart-drawer-upsell-wrapper');
    if (upsells) {
      wrapper.insertAdjacentHTML('beforeend', upsells.innerHTML);
    }

    // if (!document.querySelector('.cart-drawer-upsell-list li')) {
    //   const upsellEl = document.querySelector('#cart-drawer-upsell');
    //   if (upsellEl) upsellEl.remove();
    // }
    
    // === ADDED ===
    // Initialize script on first load
    if (typeof window.initializeCartUpsell === 'function') {
      window.initializeCartUpsell();
    }
  }
  insertSectionCartDrawer();
  
  // Export function globally so it can be called from other scripts
  window.insertSectionCartDrawer = insertSectionCartDrawer;
    
  // This function is no longer used by new script logic
  // window.onChangeKsUpsellVariantSelector = function( select, event) { ... }

  /**
   * Manually finds and executes a script from an HTML node.
   * This is required because replaceWith() does not run scripts.
   */
  function executeScriptFromNode(node) {
    const scriptElement = node.querySelector('script');
    if (scriptElement) {
      const scriptContent = scriptElement.textContent;
      try {
        // Execute the script content in the global scope
        new Function(scriptContent)();
      } catch (e) {
        console.error("Error re-initializing upsell script:", e);
      }
    }
  }

  function listenCartDrawer() {
    const element = document.querySelector('cart-drawer');
    if (!element) return;

    let timer;
     
    const observer = new MutationObserver((mutations) => { 
      if (timer) clearTimeout(timer);

      timer = setTimeout(async () => {
        try {
          const respoonse = await fetch(window.location.href);
          const text = await respoonse.text();
          const newDocument = new DOMParser().parseFromString(text, 'text/html');

          const oldWrapper = document.querySelector('#cart-drawer-upsell-wrapper');
          const newWrapper = newDocument.querySelector('#cart-drawer-upsell-wrapper');
          if (oldWrapper && newWrapper) {
            // console.log('oldWrapper1', oldWrapper)
            // console.log('newWrapper1', newWrapper)
            
            // === START OF MODIFICATION ===
            
            // 1. Manually find and execute the <script> from the new content
            // This will re-define window.initializeCartUpsell
            executeScriptFromNode(newWrapper);
            
            // 2. Replace the HTML
            oldWrapper.replaceWith(newWrapper);
            insertSectionCartDrawer();
            // 3. Now that the script is executed and function is defined,
            // call it to initialize dots, variants, etc.
            if (typeof window.initializeCartUpsell === 'function') {
              // window.initializeCartUpsell();
            }
            
            // === END OF MODIFICATION ===
          }
 
          // This function just wraps, it doesn't need to be called here
          // insertSectionCartDrawer(); 

        } catch (e) {
          console.error('Error updating cart upsell:', e);
        }
      }, 250);
    });

    observer.observe(element, {  
      attributes: true, 
      childList: true, 
      subtree: true
    });
  }
  listenCartDrawer();

  function listenCartPage() {
    const element = document.querySelector('#MainContent .cart__items');
    if (!element) return;

    let timer;
    
    const observer = new MutationObserver((mutations) => { 
      if (timer) clearTimeout(timer);

      timer = setTimeout(async () => {
        try {
          const respoonse = await fetch(window.location.href);
          const text = await respoonse.text();
          const newDocument = new DOMParser().parseFromString(text, 'text/html');

          const oldWrapper = document.querySelector('#cart-drawer-upsell-wrapper');
          const newWrapper = newDocument.querySelector('#cart-drawer-upsell-wrapper');
          
          if (oldWrapper && newWrapper) {
            // console.log('oldWrapper', oldWrapper)
            // console.log('newWrapper', newWrapper)
            
            // === START OF MODIFICATION ===
            
            // // 1. Manually find and execute the <script>
            // executeScriptFromNode(newWrapper);
            
            // // 2. Replace the HTML
            // oldWrapper.replaceWith(newWrapper);

            // 3. Call the re-defined function
            if (typeof window.initializeCartUpsell === 'function') {
              // window.initializeCartUpsell();
            }
            
             // === END OF MODIFICATION ===
          }

          // insertSectionCartPage() // This was commented out

        } catch (e) {
          console.error('Error updating cart page upsell:', e);
        }
      }, 250);
    });

    observer.observe(element, { 
      attributes: true, 
      childList: true, 
      subtree: true
    });
  }
  listenCartPage();
})();